import React from 'react';

type ContactUsLinkProps = { children?: React.ReactNode; className?: string; href: string, target?: string };

export const ContactUsLink: React.FC<ContactUsLinkProps> = ({ children, className, href, target = '_blank' }) => (
    <a className={className} href={href} target={target}>
        {children}
    </a>
);
